import { VimeoModalInfo } from './vimeo-modal.service';

export class VimeoModels {

    static readonly VoucherOverview = new VimeoModalInfo('233429809', 'vouchers.overview', 'vouchers', 'Voucher Management');

    static readonly ClassOverview = new VimeoModalInfo('233442915', 'classes.overview', 'classes', 'Class management');
    static readonly ExamsOverview = new VimeoModalInfo('233443918', 'exams.overview', 'exams', 'Exams management');
    static readonly CreateClass = new VimeoModalInfo('234297229', 'classes.add', 'classes', 'Creating classes');
    static readonly EditClass = new VimeoModalInfo('234303576', 'classes.edit', 'classes', 'Edit class');
    static readonly AddProducts = new VimeoModalInfo('234312906', 'classes.products', 'classes', 'Add products to class');
    static readonly AddInstructors = new VimeoModalInfo('234321224', 'classes.instructors', 'classes', 'Add instructors to class');
    static readonly AddLearners = new VimeoModalInfo('234324108', 'classes.learners', 'classes', 'Add learners to class');
    static readonly EnterExamDetails = new VimeoModalInfo('234496020', 'classes.exams', 'classes', 'Enter exam details');
    static readonly PreviewEmails = new VimeoModalInfo('234326330', 'classes.preview-emails', 'classes', 'Preview invitation emails');
    static readonly AssignVouchers = new VimeoModalInfo('234332471', 'classes.assign-vouchers', 'classes', 'Assign vouchers to learners');
}



// WEBPACK FOOTER //
// ./src/app/shared/components/vimeo-modal/vimeo-modals.model.ts